import { type AxiosRequestConfig } from 'axios';
import { PaginatedResponse, type AxiosDataReturn } from '../types/generic';
import api from './api-instance';
import { toast } from 'react-toastify';
import type { IFeedback } from '../types/feedback';

export const feedbacksList = async (args?: AxiosRequestConfig<any>) => {
  try {
    const res = await api.get<AxiosDataReturn<PaginatedResponse<IFeedback>>>(
      '/feedbacks/admin',
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};

export const feedbackById = async (
  id: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.get<AxiosDataReturn<IFeedback>>(
      `/feedbacks/admin/${id}`,
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};

export const feedbackDelete = async (
  id: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.delete<AxiosDataReturn<null>>(
      `/feedback/admin/${id}`,
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error('Something went wrong', { toastId: 'api-error' });
    throw e;
  }
};
